/**
 * Created by Ning Jiang on 10/1/2018.
 */

import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {TombstoneGameMode} from "../gamemode/TombstoneGameMode";
import {ITombstoneParsedServerData} from "../server/data/ITombstoneParsedServerData";

export class SuperFreespinZeroBetController extends ZeroBetController {

    constructor() {
        super();
    }

    protected calculateIsTriggered(data:ITombstoneParsedServerData):boolean {
        const isNextFirstSuperFreespin:boolean = data.superFreespinTriggeredThisSpin;
        const freespinsLeft:number = data.freespinsLeft;
        const isNextContinueSuperFreespin:boolean = data.mode === TombstoneGameMode.SUPER_FREESPIN && freespinsLeft > 0;
        return isNextFirstSuperFreespin || isNextContinueSuperFreespin;
    }

    protected getZeroBetNumberLeft(data:ParsedServerData):number {
        return data.freespinsLeft;
    }

    public shouldSubtractZeroBetCounter():boolean {
        return true;
    }

    public shouldShowZeroBetCounter():boolean {
        return true;
    }


}